import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AgFloatingFilterComponent } from 'ag-grid-angular';
import { IFloatingFilterParams } from 'ag-grid-community';
import { IntegrationService } from '../../../../shared/services/integration.service';
import { FormsModule } from '@angular/forms';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-amount-type-filter',
    templateUrl: './amount-type-filter.component.html',
    styleUrls: ['./amount-type-filter.component.scss'],
    standalone: true,
    imports: [FormsModule, CdkOverlayOrigin, NgClass, CdkConnectedOverlay]
})
export class AmountTypeFilterComponent implements OnInit, AgFloatingFilterComponent {
  @ViewChild('eInput', { read: ElementRef, static: true }) eInput: ElementRef;
  params: IFloatingFilterParams;
  currentValue: Number | null | string = null;
  selectedValue: Number | null | string = null;
  isOpen: boolean;
  amountTypeOptions = ['Dollars', 'Shares'];
  public deleteIcon: string;

  constructor(private integrationService: IntegrationService) {}

  ngOnInit(): void {
    const assetUrl = this.integrationService.getApplicationPath();
    this.deleteIcon = assetUrl + 'assets/images/Delete.svg';
  }

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
  }

  openMenu(): void {
    this.isOpen = !this.isOpen;
    if (this.currentValue) {
      this.selectedValue = this.currentValue;
    }
  }

  toggleAmountType(value: boolean): void {
    this.isOpen = value;
  }

  onParentModelChanged(parentModel: any): void {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = null;
    } else {
      this.currentValue = parentModel.filter;
    }
  }

  applyAmountType(): void {
    if (!this.selectedValue) {
      // Remove the filter
      this.params.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged(null, null);
      });
      this.isOpen = false;
      return;
    }
    this.currentValue = this.selectedValue;
    this.params.parentFilterInstance((instance: any) => {
      instance.onFloatingFilterChanged('equals', this.currentValue);
    });
    this.isOpen = false;
  }

  clearAmountType(event): void {
    event.preventDefault();
    this.selectedValue = null;
    this.applyAmountType();
  }
}
